import {
  PaymentStatus,
  ServiceInvoiceType,
} from "@redotech/redo-billing-common/service-invoice";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { ServiceInvoiceStatus } from "./service-invoice-status";

const listServiceInvoicesRowSchema = z.object({
  id: zExt.objectId(),
  teamId: zExt.objectId(),
  teamName: z.string().nullable(),
  kinds: z.array(createEnum(ServiceInvoiceType)),
  billingDueDate: z.coerce.date(),
  billedSuccessfully: z.boolean(),
  paymentStatus: createEnum(PaymentStatus).nullable(),
  billingAttempts: z.number(),
  failedPaymentsCount: z.number(),
  totalPriceCents: z.number(),
  refunded: z.boolean(),
});
export type ListServiceInvoicesRow = z.infer<
  typeof listServiceInvoicesRowSchema
>;

const listServiceInvoicesCursorSchema = z.object({
  billingDueDate: z.coerce.date(),
  id: zExt.objectId(),
});
export type ListServiceInvoicesCursor = z.infer<
  typeof listServiceInvoicesCursorSchema
>;

const listServiceInvoicesInputSchema = z.object({
  cursor: listServiceInvoicesCursorSchema.optional(),
  limit: z.number().int().min(1).max(200),
  statuses: z.array(createEnum(ServiceInvoiceStatus)).optional(),
  kinds: z.array(createEnum(ServiceInvoiceType)).optional(),
  teamIds: z.array(zExt.objectId()).optional(),
});
export type ListServiceInvoicesInput = z.infer<
  typeof listServiceInvoicesInputSchema
>;

export const listServiceInvoices = {
  name: "listServiceInvoices" as const,
  input: listServiceInvoicesInputSchema,
  output: z.object({
    rows: z.array(listServiceInvoicesRowSchema),
    nextCursor: listServiceInvoicesCursorSchema.nullable(),
  }),
};
